__turbopack_context__.v({
  "asterisk": "formStyles-module-scss-module__ji3xPW__asterisk",
  "error": "formStyles-module-scss-module__ji3xPW__error",
  "feildSet": "formStyles-module-scss-module__ji3xPW__feildSet",
  "formInstructions": "formStyles-module-scss-module__ji3xPW__formInstructions",
  "input": "formStyles-module-scss-module__ji3xPW__input",
  "inputcontainer": "formStyles-module-scss-module__ji3xPW__inputcontainer",
  "label": "formStyles-module-scss-module__ji3xPW__label",
  "mv": "formStyles-module-scss-module__ji3xPW__mv",
  "requiredAsterisk": "formStyles-module-scss-module__ji3xPW__requiredAsterisk",
  "scroll": "formStyles-module-scss-module__ji3xPW__scroll",
});
